
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'CpfEmailMatricula'
})
export class CpfEmailMatriculaPipe implements PipeTransform {
    email = false;
    guardInput = '';
    input = ''

    transform(input: any): any {
        if (input) {
            if (input.length  ===  1) {
                this.email = false;
                this.guardInput = '';
            }

            let cpfCont = 0;
            let primeiroChar = null;
            let ultimoChar = null;

            for (let i = 0; i < input.length; i++) {
                const isnum = /^\d+$/.test(input[i]);
                if (input[i]  ===  '@' || !isnum) {
                    primeiroChar = null;
                    this.email = true;
                    cpfCont = 0;
                } else {
                    cpfCont = cpfCont + 1;
                    if (primeiroChar  ===  null) {
                        primeiroChar = i;
                    }
                    if (primeiroChar !== null && ultimoChar  ===  null && cpfCont  ===  11) {
                        ultimoChar = i;
                    }

                    if (!!primeiroChar && !!ultimoChar && cpfCont  ===  11) {
                        let cpfCorrigido = ''

                        cpfCorrigido = input.substring(primeiroChar, ultimoChar)
                        this.email = false;


                        return cpfCorrigido.substring(0, 3).concat('.')
                            .concat(input.substring(3, 6))
                            .concat('.')
                            .concat(input.substring(6, 9))
                            .concat('-')
                            .concat(input.substring(9, 11));

                    }
                }
            }


            if (input.length >= 11 && !this.email) {
                if (input.length > 14) {
                    let inputLocal = input.substr(1, input.length - 1);
                    for (let i = 0; i < 3; i++) {
                        inputLocal = inputLocal.replace('.', '');
                        inputLocal = inputLocal.replace('-', '');
                    }

                    return inputLocal;
                } else {
                    input = input.toString();
                    this.guardInput = input.substring(0, 3).concat('.')
                        .concat(input.substring(3, 6))
                        .concat('.')
                        .concat(input.substring(6, 9))
                        .concat('-')
                        .concat(input.substring(9, 11));


                    return this.guardInput;
                }
            }
            return input

        }

    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/cpf-email-matricula.pipe.ts